import * as imsColor from 'app/shared/utilities/ims_color';
import { ConfigService, ImsHealthConfig } from 'app/config/config.service';

import configUtils from 'app/config_utils';

const buildUrl = configUtils.buildUrl;

// This permits for graceful handling of IMS instances accessed on non-standard hostnames or ports
// e.g. through an OpenVPN tunnel or an SSH-forwarded port
const baseApiUrl = buildUrl('/api/');
const baseCameraUrl = buildUrl('/camera/');
const baseGenericInterrogatorUrl = buildUrl('/generic_magic/');
const baseServiceHealthUrl = buildUrl('/service_health/');

const colors = imsColor;

export const DEFAULT_CONFIG: ConfigService = {
    imsName: 'Wireless Manager',

    // The time span of data to be loaded in minutes.
    timelineMinutes: 30,

    // The API Key used to access Cesium Ion Map data.
    cesiumIonApiKey:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiIyMDRlYzMyYS1mN2RiLTQ5YmMtYjVmNi05NjJkMGEzN2Y0ZjAiLCJpZCI6OTgxLCJpYXQiOjE1MjY1NDEwNjR9.i-WIlMQ8oY1DPdd37jAN3md8ctMGvK0w9r_osRFYBYQ',

    // terrain providers for the map
    terrainProviders: [
        {
            name: 'Cesium Ion',
            cesiumIonId: 1, // This is cesium world terrain
            terrainDetailLevel: 13,
        },
        // {
        //     name: 'Generic Name',
        //     url: configUtils.buildUrl('/imagery/tilesets/terrain/layer_1/'),
        //     terrainDetailLevel: 13
        // }
    ],

    // The imagery layer form will show a warning if the detail level is above/below this value.
    terrainDetailHighWarningLevel: 15,
    terrainDetailLowWarningLevel: 12,

    // The imagery layers for the map
    imageryLayers: [
        //     {
        //         name: 'WMS Example',
        //         url: 'http://somefarm.com/arcgis/services/Aerial_Photography/Imagery_Current/ImageServer/WMSServer',
        //         proxyPrefixUrl: 'http://mapproxy.ftpsolutions.com.au/maps/proxyserver.php?',
        //         type: 'wms'
        //     },
        //     {
        //         name: 'TMS Example',
        //         url: 'http://somefarm.com:6080/flyover/farm_name',
        //         type: 'tms'
        //     },
        //     {
        //         'name': 'ArcGIS Example',
        //         'url':'http://somefarm.com.au:6080/arcgis/rest/services/Geocortex/Mining/MapServer/',
        //         'type': 'arcgis'
        //     },
    ],

    apiUrlRoot: baseApiUrl,

    cameraUrlRoot: baseCameraUrl,

    // Cameras (cctv) username
    camerasUsername: 'user',

    // Cameras (cctv) password
    camerasPassword: 'pass',

    // To enable alerts set this to true, and optionally set email and sms as well
    alerting: {
        email: false,
        sms: false,
        ticket: true,
        auto_acknowledge: true,
    },

    // To enable zones set this to true
    zones: true,

    // Timeline playback loops when this is enabled
    loopTimeline: false,

    // Demo mode enables a few demo-only features such as all right click options
    demoMode: false,

    // An array of tags (e.g. ['ImsPanelService']) that are used to enable logging
    debug: [],

    // Some services use this flag to change behaviour in order to make dev easier
    devMode: false,

    // The assumed default RF Frequency used for coverage planning in Mhz
    baseRFFrequency: 2337,

    // The assumed default RF Broadcast power used for coverage planning in milliwatts
    baseRFBroadcastPower: 100,

    // The assumed default RF Tx antenna gain used for coverage planning in decibels
    baseRFTxAntennaGain: 0,

    // The assumed default RF Rx antenna gain used for coverage planning in decibels
    baseRFRxAntennaGain: 0,

    // The assumed default RF Tx antenna height used for coverage planning in metres
    baseRFTxAntennaHeight: null,

    // The assumed default RF Rx antenna height used for coverage planning in metres
    baseRFRxAntennaHeight: 4,

    // The assumed default RF minimum received signal strength used for coverage planning in decibels
    baseRFRSSICutoff: -80,

    // logical viewControllers tab - this currently only contains the next hop graph
    logicalViews: true,

    // Show the 'Cameras' tab in the overview pane
    camerasTab: false,

    // Show the incidents / tickets tab
    ticketsTab: true,

    // The IP Device tags that are displayed in the center and in the available functions to select for IP Devices
    aggregateTableTags: ['Core', 'Ingress', 'Backhaul', 'Trailer', 'Vehicle', 'AHS'],

    // Enabling OIDC will show the login button in the login page and allow the OIDC auth flow
    oidcEnabled: false,

    // Enabling will only allow the OIDC auth flow, redirecting users to the oidc login
    oidcOnlyAuthEnabled: false,

    // Customize the OIDC login button text
    oidcLoginLabel: null,

    // Set allowUnsafeCredentialsInclude if you need to cookies to be sent with requests within different origins.
    // One example is where cypress e2e uses a custom port on the front end and the api,
    // which requires using include for OIDC to work
    allowUnsafeCredentialsInclude: null,

    // Ability to change password
    allowChangePassword: false,

    // KMZ Functionality turned on?
    generateKmz: true,

    // Layer to use for KMZ
    // 'kmzWmsLayerUrl': {
    //     url: '',
    //     north: '',
    //     south: '',
    //     east: '',
    //     west: '',
    // },

    // Allow entities to be displayed when zoomed out
    globalFarmMode: false,

    baseGlobeColor: colors.IMS_BLACK,

    // Legacy name was solarControllerBatteryVoltageColorConfig
    solarControllerBatteryVoltageColorRendererConfig: {
        points: [
            { value: 24.4, color: colors.IMS_RED },
            { value: 24.75, color: colors.IMS_ORANGE },
            { value: 25.1, color: colors.IMS_GOLD },
            { value: 100, color: colors.IMS_LIME },
        ],
        default: colors.IMS_WHITE,
        type: 'traffic_light',
    },

    // Legacy name was aggregateTableSolarColorRendererConfig
    solarControllerPanelVoltageColorRendererConfig: {
        points: [
            { value: 24.4, color: colors.IMS_RED },
            { value: 24.75, color: colors.IMS_ORANGE },
            { value: 25.1, color: colors.IMS_GOLD },
            { value: 100, color: colors.IMS_GREEN },
        ],
        default: colors.IMS_WHITE,
        type: 'traffic_light',
    },

    solarControllerBatteryTempColorRendererConfig: {
        points: [
            { value: 60, color: colors.IMS_RED },
            { value: 45, color: colors.IMS_ORANGE },
            { value: 44, color: colors.IMS_LIME },
        ],
        reverse: true,
        type: 'traffic_light',
    },

    solarControllerBatteryCurrentColorRendererConfig: {
        points: [
            { value: 0.0, color: colors.IMS_RED },
            { value: 0.1, color: colors.IMS_LIME },
        ],
        default: colors.IMS_WHITE,
        type: 'traffic_light',
    },

    solarControllerPanelCurrentColorRendererConfig: {
        points: [
            { value: 0.0, color: colors.IMS_RED },
            { value: 0.1, color: colors.IMS_LIME },
        ],
        default: colors.IMS_WHITE,
        type: 'traffic_light',
    },

    solarControllerInputPowerColorRendererConfig: {
        points: [
            { value: 0.0, color: colors.IMS_RED },
            { value: 0.1, color: colors.IMS_LIME },
        ],
        default: colors.IMS_WHITE,
        type: 'traffic_light',
    },

    solarControllerOutputPowerColorRendererConfig: {
        points: [
            { value: 0.0, color: colors.IMS_RED },
            { value: 0.1, color: colors.IMS_LIME },
        ],
        default: colors.IMS_WHITE,
        type: 'traffic_light',
    },

    rssiColorRendererConfig: {
        points: [
            { value: -85, color: colors.IMS_RED },
            { value: -80, color: colors.IMS_ORANGE },
            { value: -75, color: colors.IMS_LIME },
        ],
        type: 'gradient',
    },

    // See http://usatcorp.com/faqs/understanding-lte-signal-strength-values/
    rsrpColorRendererConfig: {
        points: [
            { value: -112, color: colors.IMS_RED },
            { value: -103, color: colors.IMS_ORANGE },
            { value: -85, color: colors.IMS_LIME },
        ],
        type: 'gradient',
    },

    rsrqColorRendererConfig: {
        points: [
            { value: -11, color: colors.IMS_RED },
            { value: -10, color: colors.IMS_ORANGE },
            { value: -6, color: colors.IMS_LIME },
        ],
        type: 'gradient',
    },

    snrColorRendererConfig: {
        points: [
            { value: 5, color: colors.IMS_RED },
            { value: 10, color: colors.IMS_ORANGE },
            { value: 15, color: colors.IMS_LIME },
        ],
        default: colors.IMS_WHITE,
        type: 'gradient',
    },

    noiseColorRendererConfig: {
        points: [
            { value: -75, color: colors.IMS_RED },
            { value: -85, color: colors.IMS_ORANGE },
            { value: -95, color: colors.IMS_LIME },
        ],
        type: 'gradient',
    },

    sinrColorRendererConfig: {
        points: [
            { value: 7, color: colors.IMS_RED },
            { value: 10, color: colors.IMS_ORANGE },
            { value: 12.5, color: colors.IMS_LIME },
        ],
        default: colors.IMS_WHITE,
        type: 'gradient',
    },

    costColorRendererConfig: {
        points: [
            // { value: 5000, color: colors.IMS_LIME },
            // { value: 10000, color: colors.IMS_ORANGE },
            // { value: 20000, color: colors.IMS_RED }
            { value: 100, color: colors.IMS_LIME },
            { value: 250, color: colors.IMS_ORANGE },
            { value: 500, color: colors.IMS_RED },
        ],
        default: colors.IMS_WHITE,
        type: 'gradient',
    },

    // The following config will color:
    // From 0-39 as LIME
    // From 40-60 as YELLOW
    // From 61-100 as RED
    channelUtilisationColorRendererConfig: {
        points: [
            { value: 39, color: colors.IMS_LIME },
            { value: 60, color: colors.IMS_ORANGE },
            { value: 100, color: colors.IMS_RED },
        ],
        default: colors.IMS_WHITE,
        type: 'traffic_light',
    },

    hardwareStatColorRendererConfig: {
        points: [
            { value: 50, color: imsColor.IMS_LIME },
            { value: 60, color: imsColor.IMS_ORANGE },
            { value: 80, color: imsColor.IMS_RED },
        ],
        reverse: true,
        type: 'gradient',
    },

    latencyColorRendererConfig: {
        points: [
            { value: 100, color: imsColor.IMS_RED },
            { value: 70, color: imsColor.IMS_ORANGE },
            { value: 0, color: imsColor.IMS_LIME },
        ],
        // ping timeout
        default: imsColor.IMS_RED,
        type: 'traffic_light',
        reverse: true,
        default_name: 'Timeout',
    },

    connectivityColorRendererConfig: {
        points: [
            { value: 0, color: imsColor.IMS_RED },
            { value: 0.5, color: imsColor.IMS_ORANGE_RED },
            { value: 0.95, color: imsColor.IMS_ORANGE },
            { value: 1, color: imsColor.IMS_LIME },
        ],
        default: imsColor.IMS_WHITE,
        type: 'traffic_light',
    },

    txRateColorRendererConfig: {
        points: [
            { value: 1, color: imsColor.IMS_RED },
            { value: 12, color: imsColor.IMS_ORANGE },
            { value: 36, color: imsColor.IMS_LIME },
        ],
        type: 'gradient',
    },

    rxRateColorRendererConfig: {
        points: [
            { value: 1, color: imsColor.IMS_RED },
            { value: 12, color: imsColor.IMS_ORANGE },
            { value: 36, color: imsColor.IMS_LIME },
        ],
        type: 'gradient',
    },

    packetConfigs: [
        // Example config
        // {
        //     humanName: 'Super Packets',
        //     logicalName: 'packets1',
        //     colorRendererConfig: {
        //         points: [
        //             {value: 24.4, color: colors.IMS_RED},
        //             {value: 24.75, color: colors.IMS_ORANGE},
        //             {value: 25.1, color: colors.IMS_GOLD},
        //             {value: 100, color: colors.IMS_LIME}
        //         ],
        //         default: colors.IMS_RED,
        //         type: 'traffic_light'
        //     },
        // }
    ],

    // Removes the base map layer, this is required if there is no internet access to the front end
    removeBaseBingLayer: false,

    // Attempts to retrieve the IP Address of the front-end docker container's host and set it as apiUrlRoot
    // It will use the existing port number
    autoCalcApiIP: false,

    // Whether the 3D Terrain toggle is enabled for the map (experimental)
    map3DTerrainEnabled: true,

    // The seconds difference between the real current time and the app's current time
    liveLatency: 30,

    // The minimum distance (in seconds) between the edge of the timeline and the cursor. How close the cursor can be before the timeline is pushed forwards or backwards.
    // In live mode, this is the distance between the cursor and app current time.
    streamMargin: 20,

    // The distance (in seconds) on either side of the app current time that is still considered 'live mode', if the cursor is withing this number of seconds of the app current time it will stick to live mode
    liveTolerance: 20,

    // The scalar value of a dashboard items timeFrame which dictates how fast it should refresh. E.g. 1/15 of a chart time frame of 30 minutes would mean the chart would refresh every 2 minutes the cursor moves
    dashboardRefreshMultiplier: 1 / 15,

    // The throttle time (in milliseconds) for time collections listening for time change events.
    statCollectionRefreshThrottle: 2000,

    // Require a google account to login
    requireGoogleSignIn: false,

    // The client id to use for oauth sign in (console.cloud.google.com)
    googleClientID: '273474579687-cv1nsvd4saf205vmv62n2lllrcp6vnd1.apps.googleusercontent.com',

    // Prototype view label override
    prototypeViewLabel: 'Prototype',

    // The default view that will be used on page load. Note if you want the prototype view,
    // but it has been labeled something else with the prototypeViewLabel, you still should use
    // the view name 'prototype'
    defaultViewName: null,

    // Whether of not imsql views components are enabled over the app.
    // This currently includes the IMSQL query page (overview tab), IMSQL triggers (trigger type), and IMSQL dashboard items
    // options are null
    // null     no imsql feature
    // 'all'    every has access to imsql feature
    // 'admin'  only logged in admin users have access
    enableIMSQL: 'admin', // 'admin' | 'all' | null

    // Max panels per dashboard tab to permit
    maxPanelsInDashboardTab: 25,

    //Note, this won't actually be respected until some work has been done in the API and frontend
    maxUploadSize: 100000000,

    // Max number of dashboard tabs to permit
    maxTabsInDashboard: 20,

    // Whether QR Code is shown in the frontend
    qrCodeEnabledForDesktop: false,

    // Partially completed feature. Only turn on for dev
    // experimentation.
    enableStoreAndForward: false,

    // Enable the overview config tab (boolean).
    // Will only be visible if the user is staff, admin or a member of the 'ims_manager' group
    enableConfigTab: true,

    // The amount of time the frontend will wait for rf plan terrain height sampling to
    // complete
    rfPlanTimeoutMs: 20000,

    // The amount of time MapService.getHeight will wait for cesium to sample the
    // height of a single point. Currently only effects the context menu.
    sampleHeightTimeoutMs: 1500,

    // The upper limit when fetching heat map data points
    heatMapDataLimit: 75000,

    // The interpolation seconds limit to use when showing 'not interpolated' data
    heatMapInterpolationLimitSeconds: 10,

    // The number of times to try per each heatmap chunk
    heatMapDatabaseFailLimitPerChunk: 2,

    // the number of times a heatmap chunk database call can fail (per heatmap)
    heatMapDatabaseFailLimit: 10,

    // config for TimeIntervalChunker
    timeIntervalChunkSolarControllerStats: {
        minSegmentSize: 10,
        maxSegmentSize: 500,
        padding: 300,
    },
    timeIntervalChunkIpDeviceLog: {
        minSegmentSize: 10,
        maxSegmentSize: 500,
        padding: 300,
    },
    timeIntervalChunkTriggerStats: {
        minSegmentSize: 10,
        maxSegmentSize: 300,
        padding: 300,
    },
    timeIntervalChunkLocationStats: {
        minSegmentSize: 10,
        maxSegmentSize: 500,
        padding: 400,
    },
    timeIntervalChunkDynamicStats: {
        minSegmentSize: 10,
        maxSegmentSize: 300,
        padding: 300,
    },
    timeIntervalChunkIpDeviceStats: {
        minSegmentSize: 10,
        maxSegmentSize: 180,
        padding: 300,
    },

    // The maximum number of seconds that locations can be interpolated over.
    // If the time between two location samples is greater than this value, then the location
    // will hold at the previous sample and not be interpolated.
    locationInterpolationCutoffSeconds: 600,

    // When true, will pull the front end config stored in the API and overlay it over the contents of
    // config.js. When false, only config.js will be used. This should only be set to false for dev!
    enableApiStoredFrontEndConfig: true,

    // whether to request all custom forms be opened in debug mode
    openFormsInDebugMode: false,

    //this determines the size of each heatmap request.
    heatMapChunkSize: 25000,

    // These options will be displayed as the max point count options for heat maps
    heatMapSelectableOptions: [
        { display: 'Low (30,000)', value: 30_000 },
        { display: 'Medium (75,000)', value: 75_000 },
        { display: 'High (150,000)', value: 150_000 },
        { display: 'Very High (300,000)', value: 300_000 },
    ],

    // Options for setting the CoverageMap resolution in pixels per km
    pixelsPerKmSelectableOptions: [
        { display: 'Very Low (25)', value: 25 },
        { display: 'Low (50)', value: 50 },
        { display: 'Medium (75)', value: 75 },
        { display: 'High (100)', value: 100 },
        { display: 'Very High (150)', value: 150 },
    ],

    // default pixel km value for CoverageMap
    pixelsPerKmDefaultOption: 75,

    // maximum resolution for rf planing
    rfPlanMaxResolution: 1600,

    // This is the 'granularity' of IMS.
    // This is the max frequency (in seconds) that the infobox data and map colors will update
    imsBaseTimeResolution: 1,

    // The default Cesium framerate
    framerate: 60,

    // Base timeout in milliseconds for GET requests
    maxGetTimeout: 120000,

    // Base timeout in milliseconds for POST, PUT, PATCH and DELETE requests
    maxPostPutPatchDeleteTimeout: 120000,

    // ims quickstart guide link
    imsQuickStartGuideLink: 'https://ftpsolutions.helpjuice.com/en_AU/ims-quick-start-guide/',

    // add a black outline to connection lines
    connectionOutline: false,

    // display throughput (presentation of avg_rx_bps and avg_tx_bps) as bits if true (bytes if false)
    throughputAsBits: true,

    // a http service currently living in the back-end container
    //  which gives us access to the remote instance service
    genericInterrogatorServiceUrl: baseGenericInterrogatorUrl,

    // Provides an ordering to the default radio stat list shown in the bottom chart and uses constants defined in
    // app/config/config_utils.js
    bottomChartRadioStatOrderingWhitelist: [],

    // Display an FPS counter on the Cesium map. Used for staged environments
    debugShowFramesPerSecond: false,

    // This is for dynamically generating the forms for the matched object type from the schema
    // e.g.:
    // dynamicSchemaTypeDict: {
    //     asset: {
    //         // type id: [list of schemas we want to show for this type]
    //         1: ['Estimated Movement', 'Estimated Movement By Zone'],
    //         2: ['Estimated Movement']
    //     },
    //     ip_device: {
    //         // type id: [list of schemas we want to show for this type]
    //         1: ['Estimated Movement', 'Estimated Movement By Zone'],
    //         2: ['Estimated Movement']
    //     }
    // },
    dynamicSchemaTypeDict: {
        asset: {},
        ip_device: {},
    },

    // Similar to the dynamic stat data frequency value
    // IMPORTANT: given the way this variable is currently used in the frontend code, it's not possible to allow
    // this to be set in the API's front_end_config end point.
    ipDeviceStatDataFrequency: 8,

    // The pixel size for items on the cesium map. Make it bigger or smaller to suit the screen size
    // and icons.
    // Whole positive numbers only please.
    cesiumAssetPixelSize: 36,
    cesiumAssetLabelPixelSize: 14,
    cesiumIndicatorLabelPixelSize: 13,
    cesiumZoneLabelPixelSize: 15,

    // This is the mac address prefix for IoTBoxes.
    macPrefix: '5a:e7:ec',

    // Parser regex or function.
    macParser: /.{1,6}$/g,

    // Used when the macParser is a regex, the decoder will return this index from the list of
    // matches.
    macParserGroup: 0,

    // 30s may seem like a lot - in practice it's hard to carefully sync the requests to the internet service, IMS and the browser
    // enough to absorb any slight delays, so we just have to drag out the tolerance a bit
    timeSyncThreshold: 30, // +/- 30 seconds

    // How often to run the time sync check
    timeSyncCheckPeriod: 90, // seconds

    // Http requests during the time sync time out after this period
    timeSyncHttpRequestTimeout: 5, // seconds

    // Allow customization of the graph max time slice
    maxNumberOfSlices: 300,

    // Show/Hide the QR button on the IP device MAC input
    showMacAddressQRCodeButton: false,

    // This is the minimum panel width for dashboard items. The dashboard is 12 columns wide, so a
    // width of 4 means no more than 3 panels per row. Don't set this to greater than 4. it will break default tabs!
    gridsterMinSizeX: 4,

    // Automatically reduce the header font size for dashboard panels when they are too small.
    autoResizeDashboardPanelHeaderText: true,

    // whether to enable the path profiling between two assets via the context menu
    showAssetPathProfileInContextMenu: true,

    // Extra trigger time frames.
    // Example entry for 1.5 hours:
    // 5400000: {
    //    display: '1.5 hours'
    // }
    // Note the key is the time frame in milliseconds
    // The display value is the value shown in the trigger timeframe dropdown
    extraTriggerTimeFrames: {},

    // Show link buttons in the center panel. Can have multiple, e.g.:
    // centerPanelLinkButtons: [
    //    {
    //        displayName: "My link",
    //        url: "https://www.ftpsolutions.com.au"
    //    }
    // ]

    // TODO: change this default to true once Cesium 1.94.4 has been released (as long as it contains
    //  https://github.com/CesiumGS/cesium/pull/10425) and naturally as long as we upgrade to that version of Cesium
    enableArcGisTerrain: false,

    centerPanelLinkButtons: [],

    // feature flag for the new date and time widgets
    useNewDateTimeWidgets: false,

    // feature flag for the search widget
    enableLocationSearch: true,
    // text to display as the search widget's placeholder
    locationSearchInputText: 'Enter an Asset, IP Device, Zone, Address or GPS coordinates',

    // should the cesium asset manager update the view components
    //  per frame (with location stats), or throttled to the base time resolution thing (default)
    updateAssetViewComponentsWithLocation: false,

    // show the contact FTP button in the top-bar help menu
    showContactFTPButton: true,

    // show the ims survey button in the top-bar help menu
    showIMSSurveyButton: true,

    // show the support ticket button in the top-bar help menu
    showSupportTicketButton: true,

    // feature flag for the new feature layer
    enableFeatureLayers: true,

    // feature flag for the base globe colour in the admin config
    enableBaseGlobeColour: true,

    // Provides entities support for the triggers dropdowns
    triggerOptions: [],

    // feature flag for exposing the IPDevice.sibling_asset_id field
    enableSiblingAssetForIPDevices: false,

    // feature flag for exposing the Asset.is_legacy_anchor field
    enableIsLegacyAnchorForAssets: false,

    // Populate the dropdown for dynamic stat STRING filter fields in Triggers and HeatMap with distinct subgroup values from the database
    enableDropdownForDynamicStringFields: true,

    // feature flag for enabling the Asset Integration Template functionality
    enableAssetIntegrationTemplate: true,

    // feature flag for enabling adding the ip device name to the radio tooltip on dashboards
    addIPDeviceNameToRadioChartTooltip: true,

    // feature flag for enabling the detailed next hop information in the infobox
    showDetailedNextHopInfo: false,

    // feature flag for enabling the ServiceNow integration (toggled off - new feature under development)
    enableServiceNowIntegration: false,

    // TODO: for Cypress testing only! this swallows the errors that can happen somewhere between the
    //   fast interactions that it does and the {force: true} behaviour- doesn't seem to come up in prod
    //   so you shouldn't need this in prod (and shouldn't use it!)
    convertDestructorDestroyErrorsToWarnings: false,

    // centralize cursor in timeline if
    // a timestamp is selected outside the current timeframe
    centralizeTimelineCursor: true,

    // only effects the licensing page
    // users that are not on the model will not see the licensed vs active count module
    clientOnNewPricingModel: false,

    // An inclusion list of the type/column combos that will use the
    // time chunked heat map as opposed to the limit chunked heat map.
    // In general this method is less preferred because it will be a great deal
    // slower!
    timeChunkedHeatMapDataRequesterInclusionlist: [
        {
            imsType: 'ip_device_stat',
            columnName: 'next_hop_ip_device_id',
        },
        {
            imsType: 'ip_device_stat',
            columnName: 'avg_rssi',
        },
        {
            imsType: 'ip_device_stat',
            columnName: 'noise',
        },
        {
            imsType: 'ip_device_stat',
            columnName: 'avg_rssi',
        },
        {
            imsType: 'ip_device_stat',
            columnName: 'avg_rsrp',
        },
        {
            imsType: 'ip_device_stat',
            columnName: 'avg_rsrq',
        },
        {
            imsType: 'ip_device_stat',
            columnName: 'channel_utilisation',
        },
        {
            imsType: 'ip_device_stat',
            columnName: 'snr',
        },
        {
            imsType: 'ip_device_stat',
            columnName: 'avg_sinr',
        },
        {
            imsType: 'ip_device_stat',
            columnName: 'avg_tx_rate',
        },
        {
            imsType: 'ip_device_stat',
            columnName: 'avg_rx_rate',
        },
    ],

    // The initial size of the heat map chunk when using time based chunking
    initialHeatMapTimeChunkSizeSeconds: 600,

    // The amount to adjust the heatmap chunk size when using time based chunking
    heatMapTimeChunkSizeSecondsAdjustment: 600,
    thumbnailHeight: 150,
    thumbnailWidth: 150,

    imsHealthConfig: {
        // a proxied and cached endpoint in ims-router that returns the result of a specific cAdvisor
        // query against Prometheus
        url: baseServiceHealthUrl,
        // rate at which the service health updates in seconds
        refreshInterval: 10,
        // the age a service health entry is permitted to reach before being declared not running
        // A higher value here stops the service health from flickering on and off
        ageTolerance: 30,
        // Default to true for now so as not to scare users when we first deploy it; once we've got confidence and sorted out all
        // prometheus / ims_router configs in prod (particularly around multi-VM deployments) we can change the default to false
        // hide any indication of service health if the result was unreliable (e.g. prometheus / ims-router down)
        hideIfUnreliable: true,
        // whether the front end attempts to filter out containers that have an older version if multiple containers
        // with the same name and source are being reported
        hideOldContainers: true,
    } as ImsHealthConfig,

    // whether to get and display the /service_heath/ endpoint data
    enableImsHealth: true,

    // allow adding pollers to IMS from the front-end
    enablePollerAdd: false,

    // whether to use the default device pixel ratio or 1.0
    useDevicePixelRatio: false,

    // timeout for the camera preview page, default to 15 seconds
    cameraPreviewPageLoadTimeout: 15000,

    //set up cesium to allow for terrain overlays
    enableTerrainOverlays: false,

    // Used for agriculture: Reduces the opacity of all unselected assets when an asset is selected
    enableOpacityChangeOnAssetSelection: false,

    // Enables a way to get the asset menu to appear in ag mode
    enableAgricultureAssetsMenu: false,

    // config for shape snapping during map drawing
    agMapSnappingConfig: {
        // search radius in pixels
        snappingSearchRadius: 30,
        // run the expensive shape picking only every N frames
        runShapePickingFrameGap: 5,
    },

    // feature flag for enabling the filter/group chart by Wi-Fi Channel/Radio Technology options
    enableChartFilterByWifiOptions: true,
    dashboardRelationshipOptions: [],
    channelColorRendererConfig: { points: [], type: 'exact' },
    rssiMapColorRendererConfig: null,
    solarControllerBatteryVoltageColorConfig: null,
    showTimeSliceOptionSingleSlice: false,
    defaultFarmId: 0,
    statBrowserCustomCells: {},
    bingAPIKey: '',
    kmzWmsLayerUrl: null,
    sentryDsn: null,
    sentryRelease: null,

    defaultHelpEmail: 'help@faarm.com.au',

    // Enables a delay on all axios responses for local development
    simulateResponseDelayMilliseconds: undefined,
};
